import DataTableColumnHeader from '@/components/datatable/DataTableColumnHeader.vue';
import BIReportTableActions from '@/components/power-bi/BIReportTableActions.vue';
import type { BIReport } from '@/types';
import type { ColumnDef } from '@tanstack/vue-table';
import { h } from 'vue';

export const columns: ColumnDef<BIReport>[] = [
    {
        accessorKey: 'id',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'bi_and_companies.id',
            }),
        meta: {
            filterType: 'number',
        },
    },
    {
        accessorKey: 'reporting_account',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'bi_and_companies.reporting_account',
            }),
    },
    {
        accessorKey: 'reporting_account_nr',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'bi_and_companies.reporting_account_nr',
            }),
    },
    {
        accessorKey: 'accounts_in_mapping_text',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'bi_and_companies.account_mapping',
            }),
    },
    {
        accessorKey: 'measurement_calculation',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'bi_and_companies.measurement_calculation',
            }),
    },
    {
        id: 'actions',
        enableHiding: false,
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'tables.actions',
            }),
        cell: ({ row }) => {
            return h(BIReportTableActions, {
                biReport: row.original,
            });
        },
    },
];
